import { Box, Stack } from "@mui/material";
import { useState } from "react";
import { AccordionTransition } from "../../common/AccordionTransition";
import { FilesFieldCard } from "../../feat/editItinerary/components/filesFieldCard";
import { TextFieldCard } from "../../feat/editItinerary/components/textFieldCard";
import { Expand } from "../../home/components/Expand";
import i18n from "../../i18n/i18next";
import { EditButton } from "./editButton";
import { UsersList } from "./usersList";

interface IFlightPassengersBodyProps {
  id?: string;
  data: any;
  renderOptions: IFlightPassengersBodyOptions;
}

interface IFlightPassengersBodyOptions {
  listFieldId: number;
  icon?: string;
  editPageId?: number;
  userListKey: string;
}
export const FlightPassengersBody = ({ id, data, renderOptions }: IFlightPassengersBodyProps) => {
  const [chevroClickOpen, setChevroClickOpen] = useState<boolean>(false);

  const userList = () => {
    const hideUserList = data?.users?.length === 0;

    return (
      <>
        <Stack direction="row" sx={{
          justifyContent: "space-between"
        }}>
          {hideUserList ? (
            <div />
          ) : (
            <Box
              onClick={() => {
                setChevroClickOpen(!chevroClickOpen);
              }}
              sx={{
                height: "24px"
              }}
            >
              <Expand expanded={chevroClickOpen} />
            </Box>
          )}

          <EditButton id={id} data={data} renderOptions={{ pageId: renderOptions.editPageId }} />
        </Stack>
        {!hideUserList && (
          <AccordionTransition open={chevroClickOpen}>
            <UsersList
              id={id}
              data={data}
              renderOptions={{
                hideChat: true,
                users: renderOptions.userListKey,
              }}
            />
          </AccordionTransition>
        )}
      </>
    );
  };

  return (
    <Stack spacing="16px">
      <TextFieldCard id={id} description={i18n.t("edit-itinerary.fields.236")} text={data.baggage_allowance} />
      <TextFieldCard id={id} description={i18n.t("edit-itinerary.fields.316")} text={data.notes} />
      <FilesFieldCard id={id} description={i18n.t("edit-itinerary.fields.documents")} files={data.documents} />
      {userList()}
    </Stack>
  );
};
